import { render, staticRenderFns } from "./step-tech-year.vue?vue&type=template&id=bc616d3e"
import script from "./step-tech-year.vue?vue&type=script&lang=ts"
export * from "./step-tech-year.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports